import request from '@/utils/request'

export function findAssessors(branchId, find) {
  return request({
    url: `/sfera/users/assessor/${branchId}`,
    method: 'get',
    params: {
      find: find
    }
  })
}

export function findProjectLeaders(branchId, find) {
  return request({
    url: `/sfera/users/projectleader/${branchId}`,
    method: 'get',
    params: {
      find: find
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/sferaUsers.js